import * as firebase from "firebase/app"

var config = {
/*  apiKey: "AIzaSyBDIKxDrf2VY4VBiVTf7oLvOcqOo4RrRCI",
  authDomain: "crdd-web.firebaseapp.com",
  projectId: "crdd-web",
  storageBucket: "crdd-web.appspot.com",
  messagingSenderId: "639762079164",
  appId: "1:639762079164:web:c7cd0495b6487ca8f79fb9",
  measurementId: "G-NEV4JTFD50"*/
  apiKey: "AIzaSyD3QkmKlIW4itcVe3uXr-5tNX-szgEYio0",
  authDomain: "crdd-api-fb719.firebaseapp.com",
  projectId: "crdd-api-fb719",
  storageBucket: "crdd-api-fb719.firebasestorage.app",
  messagingSenderId: "636286469",
  appId: "1:636286469:web:5f22f38ff515aa816a8e6c"
};
let firebaseConfig = firebase.initializeApp(config);
export default firebaseConfig;
